<div class="table-responsive" [class.overflow-hidden]="emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover directory-list-table footable">
        <thead>
            <tr [ngClass]="{'noSort': data.length < 2}">
                <th></th>
                <th (click)="orderBy('suite.suiteNumber', $event)" class="footable-sorted">
                    Unit<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="directoryService.buildings.length != 1"
                    (click)="orderBy('building.name', $event)">
                    Building<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('petType.name', $event)">
                    Pet Type<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView"
                    (click)="orderBy('note', $event)">
                    Notes<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView"
                    (click)="orderBy('name', $event)">
                    Name<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView"
                    (click)="orderBy('breed', $event)">
                    Breed<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView"
                    (click)="orderBy('dateOfBirth', $event)">
                    DOB<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="directoryService.archivedFilterIsOn()">Status</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data" (click)="toggleCheck(item)">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>{{item.suiteNumber}}</td>
                <td *ngIf="directoryService.buildings.length != 1">{{item.buildingName}}</td>
                <td>{{item.petTypeName || '-'}}</td>
                <td *ngIf="!directoryService.showDetailedView">{{item.note || '-'}}</td>
                <td *ngIf="!directoryService.showDetailedView">{{item.name || '-'}}</td>
                <td *ngIf="!directoryService.showDetailedView">{{item.breed || '-'}}</td>
                <td *ngIf="!directoryService.showDetailedView">
                    {{item.dateOfBirth ? (item.dateOfBirth | date:'yyyy-MM-dd') : '-'}}
                </td>
                <td *ngIf="directoryService.archivedFilterIsOn()">
                    <span *ngIf="directoryService.dateIsEarlierThanCurrent(item.moveOutDate)"
                          title="{{item.moveOutDate | date: 'dd.MM.yyyy'}}"
                          class="label archived-item">
                        Archived
                    </span>
                </td>
            </tr>
            <tr *ngFor="let item of emptyRowService.emptyRow" style="cursor: default;">
                <td><div class="psevdo-checkbox"></div></td>
                <td></td>
                <td *ngIf="directoryService.buildings.length != 1"></td>
                <td></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
                <td *ngIf="!directoryService.showDetailedView"></td>
                <td *ngIf="directoryService.archivedFilterIsOn()"></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message
            [isEmpty]="!directoryService.directoryData['pets'].total"
            [isServiceUnavailable]="directoryService.showServiceUnavailable"
            [isLoading]="directoryService.spinnerShow">
        You have no pets listed on the system<br>
        <span *ngIf="directoryService.account.canUpdate('bldn')">
            <a href="javascript://" (click)="directoryService.showModal()" class="mtv-primary-color clickable-text">add a pet</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/pets-list/pets-list.component.html